


















































import {
	computed,
	defineComponent,
	ref,
} from '@vue/composition-api';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import { canManageCategories } from '@front-app/util/permission';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import ColumnHeader from '@front-app/components/layouts/columns/ColumnHeader.vue';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import ScrollingColumn from '@front-app/components/layouts/columns/ScrollingColumn.vue';
import ManageCategoryRow from '@front-app/modules/group/categories/components/ManageCategoryRow.vue';
import { useAdminAccess } from '@front-app/modules/group/hooks/useAdminAccess';
import { GroupCategoriesStore } from '@front-app/store/singletons/GroupCategories';
import CategoryNameInput from '@front-app/modules/group/categories/components/CategoryNameInput.vue';
import { Routes } from '@front-app/constants/routes';

export default defineComponent({
	components: {
		ColumnContainer,
		ColumnHeader,
		ErrorCard,
		ScrollingColumn,
		PaddedContent,
		ManageCategoryRow,
		CategoryNameInput,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
	},
	setup(props) {
		const {
			track,
			isLoading: isLoadingGroups,
			isSuccess: hasLoadedGroups,
			isError: groupLoadingFailed,
		} = useAsyncStatus();
		track(GroupsStore.getInstance().fetchGroupsOnce());
		const group = computed(() => GroupsStore.getInstance().groupById(props.groupId));
		const { hasConfigurationAccess } = useAdminAccess(group);
		const canManageCategoriesForCurrentGroup = computed(() => canManageCategories(group.value));

		const categories = computed(() => group.value?.categories || []);

		// Adding a category
		const newCategoryStatus = useAsyncStatus();
		const newCategoryName = ref('');
		const addCategory = async () => {
			await newCategoryStatus.track(GroupCategoriesStore.addCategory(props.groupId, newCategoryName.value));
			newCategoryStatus.clear(3000);
			newCategoryName.value = '';
		};

		return {
			GROUP_MAIN_ROUTE: Routes.GROUP_MAIN,
			// Permissions
			hasConfigurationAccess,
			canManageCategoriesForCurrentGroup,
			// Adding a category
			newCategoryStatus: newCategoryStatus.status,
			newCategoryName,
			addCategory,
			// Group things
			categories,
			isLoadingGroups,
			hasLoadedGroups,
			groupLoadingFailed,
		};
	},
});
